import React, { useRef, useEffect } from "react";
import { Tooltip } from "@/components/common/Tooltip";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button } from "./Button";
export type CopyStatus = "idle" | "copying" | "copied" | "error";

interface CopyActionButtonProps {
  status: CopyStatus;
  onCopy: (e?: React.MouseEvent) => void;
  onOpenPicker?: (e?: React.MouseEvent) => void;
  label?: string;
  size?: "xs" | "sm";
}

export const CopyActionButton: React.FC<CopyActionButtonProps> = ({
  status,
  onCopy,
  onOpenPicker,
  label = "Copy Table",
  size = "xs",
}) => {
  const iconSize = size === "xs" ? "0.75rem" : "0.875rem";
  const prevStatusRef = useRef(status);
  const showErrorFlash =
    prevStatusRef.current === "copying" && status === "error";

  useEffect(() => {
    prevStatusRef.current = status;
  }, [status]);

  if (status === "copied") {
    return (
      <span className="px-2 py-1 text-accent-regular bg-accent-15 text-xs capitalize animate-status-in">
        Copied
      </span>
    );
  }

  return (
    <div className="inline-flex items-center gap-1">
      <Button
        size={size}
        variant="primary"
        onClick={onCopy}
        loading={status === "copying"}
      >
        {label}
      </Button>
      {onOpenPicker && (
        <Tooltip title="Choose a different model">
          <button
            aria-label="Choose a different model"
            className="px-0.5 py-1 text-xs text-fg-muted-medium hover:text-accent transition-colors cursor-pointer"
            onClick={onOpenPicker}
            disabled={status === "copying"}
          >
            <ArrowDropDownIcon style={{ fontSize: "1rem" }} />
          </button>
        </Tooltip>
      )}
      {showErrorFlash && (
        <ErrorOutlineIcon
          className="text-error animate-status-flash"
          style={{ fontSize: iconSize }}
        />
      )}
    </div>
  );
};
